"use strict";
/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
Object.defineProperty(exports, "__esModule", { value: true });
var styles = [".alert[_ngcontent-%COMP%]{position:absolute;height:37px;z-index:1;width:100%;border-radius:0;margin:0;border-bottom:1px solid rgba(0,0,0,.2)}"];
exports.styles = styles;
